import { BillingDayOfMonthModel } from '../BillingDayOfMonth';
import { lastModificationFromDTO } from '../relationship/amendment';
import { RelationshipFundingSourceModel } from '../RelationshipFundingSourceModel';
import * as timeModel from '../time';
export const fromDTO = (dto)=>{
    var _dto_hasAmendmentDraft, _dto_withdrawnForEditing, _dto_hasBilledImmediatelyService, _dto_hasExplicitApprovalToS, _dto_hasServiceBundles, _dto_hasOptionalServices;
    return {
        id: dto.id,
        billingDayOfMonth: BillingDayOfMonthModel.make(dto.billingDayOfMonth),
        customer: dto.customer,
        adHocChargeStatus: dto.adHocChargeStatus,
        invoiceStatus: dto.invoiceStatus,
        serviceStatus: dto.serviceStatus,
        isSample: dto.isSample,
        progressStatus: dto.progressStatus,
        progressStatusTimestamp: dto.progressStatusTimestamp,
        status: dto.status,
        suggestedCustomerName: dto.suggestedCustomerName,
        title: dto.title,
        vendor: dto.vendor,
        seller: dto.seller,
        buyer: dto.buyer,
        fundingSource: dto.fundingSource && new RelationshipFundingSourceModel(dto.fundingSource),
        agreementStatusV2: dto.agreementStatusV2,
        hasAmendments: dto.hasAmendments,
        hasAmendmentDraft: (_dto_hasAmendmentDraft = dto.hasAmendmentDraft) !== null && _dto_hasAmendmentDraft !== void 0 ? _dto_hasAmendmentDraft : false,
        lastModification: lastModificationFromDTO(dto.lastModification),
        lastBilledDate: dto.lastBilledDate != null ? new Date(dto.lastBilledDate) : null,
        createdOn: new Date(dto.createdOn),
        effectiveDate: dto.effectiveDate && timeModel.fromDatestampArray(dto.effectiveDate),
        expirationDate: dto.expirationDate,
        draftId: dto.draftId,
        approvedAt: dto.approvedAt ? new Date(dto.approvedAt) : null,
        withdrawnForEditing: (_dto_withdrawnForEditing = dto.withdrawnForEditing) !== null && _dto_withdrawnForEditing !== void 0 ? _dto_withdrawnForEditing : false,
        hasBilledImmediatelyService: (_dto_hasBilledImmediatelyService = dto.hasBilledImmediatelyService) !== null && _dto_hasBilledImmediatelyService !== void 0 ? _dto_hasBilledImmediatelyService : false,
        hasExplicitApprovalToS: (_dto_hasExplicitApprovalToS = dto.hasExplicitApprovalToS) !== null && _dto_hasExplicitApprovalToS !== void 0 ? _dto_hasExplicitApprovalToS : false,
        hasSignatureToS: dto.hasSignatureToS,
        hasServiceBundles: (_dto_hasServiceBundles = dto.hasServiceBundles) !== null && _dto_hasServiceBundles !== void 0 ? _dto_hasServiceBundles : false,
        hasOptionalServices: (_dto_hasOptionalServices = dto.hasOptionalServices) !== null && _dto_hasOptionalServices !== void 0 ? _dto_hasOptionalServices : false,
        statusType: dto.statusType
    };
};
